import Compressor from "compressorjs";

export const getUrlParams = ()=> {
    const url = window.location.href;
    const queryStr = url.split('?')[1]?.split('#')[0] || '';
    const params = new URLSearchParams(queryStr);
    return params;
}

export const storage = {
    set(key, value) {
        try {
            const serialized = JSON.stringify(value);
            localStorage.setItem(key, serialized);
        } catch (error) {
            console.error('localStorage set error:', error);
        }
    },

    get(key) {
        try {
            const raw = localStorage.getItem(key);
            return raw === null ? undefined : JSON.parse(raw);
        } catch (error) {
            console.error('localStorage get error:', error);
            return undefined;
        }
    },

    remove(key) {
        localStorage.removeItem(key);
    }
};

export const isPositiveNumber= str => {
    // 先排除 null, undefined, 空字符串
    if (str == null || str === '') {
        return false;
    }

    const num = parseFloat(str);

    // 检查是否为有效数字 且 大于 0
    return isFinite(num) && num > 0;
}

export function getDeviceType() {
    const ua = navigator.userAgent.toLowerCase();

    if (/android/.test(ua)) {
        return 'android';
    }

    if (/iphone|ipad|ipod/.test(ua)) {
        return 'ios';
    }

    return 'other';
}

export async function compressImage(image) {
    return new Promise((resolve, reject) => {
        new Compressor(image, {
            quality: 0.6,
            convertSize: 2 * 1024 * 1024,
            success: function (result) {
                resolve(result)
            },
            error: function (err) {
                console.log(err.message)
                reject(image)
            },
        })
    })
}